import { useState, useEffect } from 'react';
import { FeedRegistrySettings } from './FeedWizardTab';
import { useLang, addTranslations } from './i18n';
import { T, alpha } from './poyais-ui/theme';
import PoyaisSpinner from './PoyaisSpinner';

addTranslations({
  "Custom label atayın, segment feed'ler oluşturun, Google & Meta reklamlarında hedefleme yapın.": 'Assign custom labels, build segment feeds, and target with them in Google & Meta ads.',
  'Feed Ekle': 'Add Feed',
  'Yeni Feed Bağla': 'Connect New Feed',
  'Feed Adı': 'Feed Name',
  'Feed Tipi': 'Feed Type',
  'örn: Marka Google Feed': 'e.g.: Brand Google Feed',
  'Ad ve URL zorunludur.': 'Name and URL are required.',
  'Feed eklenirken hata oluştu.': 'An error occurred while adding the feed.',
  'Ekleniyor…': 'Adding…',
  'Feed Bağla': 'Connect Feed',
  'İptal': 'Cancel',
  'Önce Feed Bağlayın': 'Connect a Feed First',
  "Feed Wizard'dan bir feed bağlayın.": 'Connect a feed from Feed Wizard.',
  'Feed İstatistikleri': 'Feed Statistics',
  'Yükleniyor…': 'Loading…',
  'toplam ürün': 'total products',
  'Kategoriler': 'Categories',
  'Fiyat Dağılımı': 'Price Distribution',
  'İndirim Dağılımı': 'Discount Distribution',
  'İndirimsiz': 'No discount',
  'Önizleme': 'Preview',
  'Custom Label Kuralları': 'Custom Label Rules',
  'Koşullara göre ürünlere otomatik label ata.': 'Automatically assign labels to products based on conditions.',
  'Önizle': 'Preview',
  'Kural Ekle': 'Add Rule',
  'Henüz kural yok': 'No rules yet',
  'Custom label kuralı ekleyerek ürünleri segmentlere ayırın.': 'Add a custom label rule to split products into segments.',
  'Tümü': 'All',
  'Öncelik': 'Priority',
  'Sil': 'Delete',
  'Yeni Kural': 'New Rule',
  'Label Değeri': 'Label Value',
  'veya özel değer girin': 'or enter a custom value',
  'Label Slot': 'Label Slot',
  'Filtre Koşulu': 'Filter Condition',
  'Kural Adı (opsiyonel)': 'Rule Name (optional)',
  'Kural adı': 'Rule name',
  'Kaydet': 'Save',
  'Custom Label Nasıl Çalışır?': 'How Does Custom Label Work?',
  'Google Ads ve Meta\'da custom_label_0-4 alanlarını kampanya hedefleme için kullanabilirsiniz. Örn: "İndirimli" label\'ı olan ürünlere farklı teklif stratejisi uygulayın.':
    'You can use the custom_label_0-4 fields in Google Ads and Meta for campaign targeting. E.g.: apply a different bidding strategy to products with the "İndirimli" label.',
  "Segment Feed'ler": 'Segment Feeds',
  'Seçili ürünlerden yeni feed oluşturun.': 'Create a new feed from selected products.',
  'Segment Oluştur': 'Create Segment',
  'Henüz segment yok': 'No segments yet',
  "Belirli ürün gruplarından özel feed'ler oluşturun.": 'Create custom feeds from specific product groups.',
  'ürün': 'products',
  'URL Kopyala': 'Copy URL',
  'XML Görüntüle': 'View XML',
  "Google Ads'e Bağla": 'Connect to Google Ads',
  "Meta Ads'e Bağla": 'Connect to Meta Ads',
  'Yeni Segment': 'New Segment',
  'Segment Adı': 'Segment Name',
  'örn: Premium Ürünler': 'e.g.: Premium Products',
  'Ürün Seç': 'Select Products',
  'seçili': 'selected',
  'Tümünü Kaldır': 'Deselect All',
  'Tümünü Seç': 'Select All',
  'Ürünler yükleniyor…': 'Loading products…',
  'indirim': 'off',
  'Label Önizleme': 'Label Preview',
  "Kurallara göre atanan label'ları görün.": 'View labels assigned by your rules.',
  'Yenile': 'Refresh',
  'Ürünlere kurallar uygulanıyor…': 'Applying rules to products…',
  'Bu feed için ürün bulunamadı.': 'No products found for this feed.',
  'Önizleme yüklenirken hata oluştu. Lütfen tekrar deneyin.': 'An error occurred while loading the preview. Please try again.',
  'Kural ekleyip "Önizle" butonuna tıklayın.': 'Add a rule and click "Preview".',
  'Ürün': 'Product',
  'İndirimli Ürünler': 'Discounted Products',
  'Min İndirim %': 'Min Discount %',
  'İndirim Aralığı': 'Discount Range',
  'Max Fiyat': 'Max Price',
  'Max Fiyat (TL)': 'Max Price (TL)',
  'Min Fiyat': 'Min Price',
  'Min Fiyat (TL)': 'Min Price (TL)',
  'Fiyat Aralığı': 'Price Range',
  'Kategori İçerir': 'Category Contains',
  'Kategori': 'Category',
  'Marka': 'Brand',
  'Marka Adı': 'Brand Name',
  'Stok Durumu': 'Stock Status',
  'Durum': 'Status',
  'Tüm Ürünler': 'All Products',
  "Google Merchant Center'a Bağlama": 'Connecting to Google Merchant Center',
  "Meta Commerce Manager'a Bağlama": 'Connecting to Meta Commerce Manager',
  'Google Shopping': 'Google Shopping',
  'Meta Katalog': 'Meta Catalog',
  'Feed URL': 'Feed URL',
  'Kopyala': 'Copy',
  'Getirme sıklığını platform üzerinden ayarlarsınız, Poyais One tarafında ek bir işlem gerekmez. Segmentteki ürünleri güncellediğinizde bu URL\'deki içerik de otomatik güncellenir.':
    'You set the fetch frequency on the platform side — no extra step is needed on the Poyais One side. When you update the products in the segment, the content at this URL updates automatically too.',
  'Anladım': 'Got it',
  'merchantcenter.google.com adresine gidip ilgili hesabı seçin.': 'Go to merchantcenter.google.com and select the relevant account.',
  "Sol menüden Ürünler > Feedler'e girin.": 'Go to Products > Feeds from the left menu.',
  '"+" ile yeni feed ekleyin, ülke ve dili seçin.': 'Add a new feed with "+", and choose the country and language.',
  'Giriş yöntemi olarak "Zamanlanmış getirme" (Scheduled fetch) seçeneğini işaretleyin.': 'Select "Scheduled fetch" as the input method.',
  "Aşağıdaki feed URL'sini yapıştırın ve günlük getirme saatini ayarlayın.": 'Paste the feed URL below and set the daily fetch time.',
  "Merchant Center hesabı Google Ads'e bağlıysa ürünler otomatik olarak Shopping / Performance Max kampanyalarında kullanılabilir hale gelir.": 'If the Merchant Center account is linked to Google Ads, the products automatically become usable in Shopping / Performance Max campaigns.',
  'business.facebook.com/commerce_manager adresine gidip ilgili kataloğu seçin (yoksa yeni katalog oluşturun).': 'Go to business.facebook.com/commerce_manager and select the relevant catalog (or create a new one if you don\'t have one).',
  "Veri Kaynakları > Yeni Veri Kaynağı Ekle'ye girin.": 'Go to Data Sources > Add New Data Source.',
  'Giriş yöntemi olarak "Zamanlanmış Feed" seçeneğini işaretleyin.': 'Select "Scheduled Feed" as the input method.',
  "Katalog onaylandıktan sonra Meta Ads Yöneticisi'nde dinamik ürün reklamları (DPA) oluşturabilirsiniz.": 'Once the catalog is approved, you can create dynamic product ads (DPA) in Meta Ads Manager.',
});

const GOLD=T.accent;
const TX=T.text,MT=T.textMidAlt,DIM=T.textDim,RED=T.redText,GREEN=T.greenText;
const BORDER=T.border,BORDER_MID=T.tableDivider,SURFACE=T.surface,TILE=T.subtleBg,TRACK=T.trackBg;
const MONO="'JetBrains Mono', monospace";
const API='/api/v1/dynamic-feed';

function useIsMobile(){
  const[m,setM]=useState(window.innerWidth<768);
  useEffect(()=>{const fn=()=>setM(window.innerWidth<768);window.addEventListener('resize',fn);return()=>window.removeEventListener('resize',fn);},[]);
  return m;
}
const FW_API='/api/v1/feed-wizard';

const LABEL_SLOTS=['custom_label_0','custom_label_1','custom_label_2','custom_label_3','custom_label_4'];
const LABEL_PRESETS=['Çok Satan','En Yeni','İndirimli','Sezonluk','Premium','Trend','Stok Azalıyor','Özel Seri','Bestseller','Sale','New Arrival','Top Rated','Limited'];

const FILTER_TYPES=[
  {id:'has_sale',      label:'İndirimli Ürünler',     fields:[]},
  {id:'discount_min',  label:'Min İndirim %',          fields:[{k:'value',l:'Minimum %',type:'number'}]},
  {id:'discount_range',label:'İndirim Aralığı',        fields:[{k:'min',l:'Min %',type:'number'},{k:'max',l:'Max %',type:'number'}]},
  {id:'price_max',     label:'Max Fiyat',              fields:[{k:'value',l:'Max Fiyat (TL)',type:'number'}]},
  {id:'price_min',     label:'Min Fiyat',              fields:[{k:'value',l:'Min Fiyat (TL)',type:'number'}]},
  {id:'price_range',   label:'Fiyat Aralığı',          fields:[{k:'min',l:'Min (TL)',type:'number'},{k:'max',l:'Max (TL)',type:'number'}]},
  {id:'category_contains',label:'Kategori İçerir',     fields:[{k:'value',l:'Kategori',type:'text'}]},
  {id:'brand_is',      label:'Marka',                  fields:[{k:'value',l:'Marka Adı',type:'text'}]},
  {id:'availability_is',label:'Stok Durumu',           fields:[{k:'value',l:'Durum',type:'select',options:['in stock','out of stock','preorder']}]},
  {id:'all',           label:'Tüm Ürünler',            fields:[]},
];

const inp:React.CSSProperties={width:'100%',background:SURFACE,border:`1px solid ${T.borderMid}`,borderRadius:9,padding:'9px 11px',fontSize:12.5,color:TX,outline:'none',boxSizing:'border-box' as const,fontFamily:'inherit'};
const tok=()=>localStorage.getItem('poyais_token')||localStorage.getItem('token')||'';
const authH=()=>({Authorization:`Bearer ${tok()}`,'Content-Type':'application/json'});

function StatBar({label,value,max,color}:{label:string;value:number;max:number;color:string}){
  return(
    <div style={{marginBottom:8}}>
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:3}}>
        <span style={{fontSize:11,color:MT,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const,maxWidth:'70%'}}>{label}</span>
        <span style={{fontSize:11,fontWeight:700,color:TX,flexShrink:0,fontFamily:MONO}}>{value}</span>
      </div>
      <div style={{height:5,background:TRACK,borderRadius:999,overflow:'hidden'}}>
        <div style={{height:'100%',width:`${max>0?Math.round(value/max*100):0}%`,background:color,borderRadius:999}}/>
      </div>
    </div>
  );
}

export default function DynamicFeedTab({clientId}:{clientId?:number}={}){
  const { t, lang } = useLang();
  const isMobile=useIsMobile();
  const[feeds,setFeeds]=useState<any[]>([]);
  const[selFeed,setSelFeed]=useState<any>(null);
  const[stats,setStats]=useState<any>(null);
  const[rules,setRules]=useState<any[]>([]);
  const[segments,setSegments]=useState<any[]>([]);
  const[preview,setPreview]=useState<any[]>([]);
  const[tab,setTab]=useState<'labels'|'segments'|'preview'>('labels');
  const[loadingStats,setLoadingStats]=useState(false);
  const[loadingPreview,setLoadingPreview]=useState(false);
  const[previewError,setPreviewError]=useState('');

  // Yeni kural form
  const[newRule,setNewRule]=useState({name:'',label_slot:'custom_label_0',label_value:'',filter_type:'has_sale',filter_value:{} as any,priority:0});
  const[showRuleForm,setShowRuleForm]=useState(false);
  const[showAddFeed,setShowAddFeed]=useState(false);
  const[newFeed,setNewFeed]=useState({name:'',src_url:'',feed_type:'google'});
  const[savingFeed,setSavingFeed]=useState(false);
  const[feedError,setFeedError]=useState('');

  // Yeni segment form
  const[newSeg,setNewSeg]=useState({name:'',filter_type:'',filter_value:{} as any});
  const[showSegForm,setShowSegForm]=useState(false);
  const[segProducts,setSegProducts]=useState<any[]>([]);
  const[selProducts,setSelProducts]=useState<Set<string>>(new Set());
  const[loadingSegProds,setLoadingSegProds]=useState(false);
  const[connectGuide,setConnectGuide]=useState<{seg:any;platform:'google'|'meta'}|null>(null);
  const[topTab,setTopTab]=useState<'main'|'settings'>('main');
  const[clients,setClients]=useState<any[]>([]);

  // client_id her zaman gönderiliyor — eskiden hiç gönderilmiyordu, bu yüzden backend
  // "hiç client_id verilmemiş" dalına düşüp kullanıcının ERİŞEBİLDİĞİ TÜM müşterilerin
  // feed'lerini (+ atanmamış/paylaşılan feed'leri) tek bir düz liste olarak dönüyordu —
  // hangi müşteri o an aktifse ona göre hiç filtrelenmiyordu. Kullanıcı canlıda yakaladı
  // (2026-09-13): Denim Trip'teyken ZsaZsaZsu'nun feed'ini görebiliyordu. Şimdi backend'in
  // zaten doğru çalışan client_id filtresi (list_feeds, feed_wizard_router.py) kullanılıyor.
  const reloadFeeds=(keepSelection?:boolean)=>{
    const qs = clientId ? `?client_id=${clientId}` : '';
    fetch(`${FW_API}/feeds${qs}`,{headers:{Authorization:`Bearer ${tok()}`}})
      .then(r=>r.ok?r.json():[]).then((fs:any[])=>{
        fs=fs.filter((f:any)=>Number(f.is_derived)!==1);
        setFeeds(fs);
        if(keepSelection&&selFeed){
          const still=fs.find((f:any)=>String(f.id)===String(selFeed.id));
          if(still) setSelFeed(still);
        } else if(fs.length>0){
          selectFeed(fs[0]);
        } else {
          setSelFeed(null);setStats(null);setRules([]);setSegments([]);setPreview([]);
        }
      }).catch(()=>{});
  };

  // Feed listesi yükle — aktif müşteri değiştiğinde de yeniden çekilmeli, aksi halde
  // önceki müşterinin feed'i seçili kalmaya devam ederdi.
  useEffect(()=>{ reloadFeeds(); },[clientId]);
  useEffect(()=>{
    fetch(`/api/v1/clients/`,{headers:{Authorization:`Bearer ${tok()}`}})
      .then(r=>r.ok?r.json():[]).then(d=>setClients(Array.isArray(d)?d:[])).catch(()=>{});
  },[]);

  const addFeed=async()=>{
    if(!newFeed.name.trim()||!newFeed.src_url.trim()){setFeedError(t('Ad ve URL zorunludur.'));return;}
    setSavingFeed(true);setFeedError('');
    try{
      const r=await fetch(`${FW_API}/feeds`,{method:'POST',headers:authH(),
        body:JSON.stringify({name:newFeed.name,src_url:newFeed.src_url,feed_type:newFeed.feed_type,template_id:'minimal-dark',formats:['sq'],client_id:clientId?String(clientId):''})});
      if(!r.ok)throw new Error('Feed eklenemedi');
      const data=await r.json();
      const qs = clientId ? `?client_id=${clientId}` : '';
      const updated=await fetch(`${FW_API}/feeds${qs}`,{headers:{Authorization:`Bearer ${tok()}`}}).then(r=>r.json());
      setFeeds(updated);
      const added=updated.find((f:any)=>f.id===data.feed_id)||updated[updated.length-1];
      if(added)selectFeed(added);
      setShowAddFeed(false);setNewFeed({name:'',src_url:'',feed_type:'google'});
    }catch(e){setFeedError(t('Feed eklenirken hata oluştu.'));}
    setSavingFeed(false);
  };

  const selectFeed=async(feed:any)=>{
    setSelFeed(feed);setStats(null);setRules([]);setSegments([]);setPreview([]);
    setLoadingStats(true);
    try{
      const[statsR,rulesR,segsR]=await Promise.all([
        fetch(`${API}/feeds/${feed.id}/stats`,{headers:authH()}).then(r=>r.json()),
        fetch(`${API}/feeds/${feed.id}/rules`,{headers:authH()}).then(r=>r.json()),
        fetch(`${API}/feeds/${feed.id}/segments`,{headers:authH()}).then(r=>r.json()),
      ]);
      setStats(statsR);setRules(rulesR);setSegments(segsR);
    }catch{}
    setLoadingStats(false);
  };

  const addRule=async()=>{
    if(!selFeed||!newRule.label_value||!newRule.filter_type)return;
    const r=await fetch(`${API}/feeds/${selFeed.id}/rules`,{method:'POST',headers:authH(),body:JSON.stringify(newRule)});
    if(r.ok){
      const updated=await fetch(`${API}/feeds/${selFeed.id}/rules`,{headers:authH()}).then(r=>r.json());
      setRules(updated);setShowRuleForm(false);
      setNewRule({name:'',label_slot:'custom_label_0',label_value:'',filter_type:'has_sale',filter_value:{},priority:0});
    }
  };

  const deleteRule=async(id:number)=>{
    await fetch(`${API}/rules/${id}`,{method:'DELETE',headers:authH()});
    setRules(prev=>prev.filter(r=>r.id!==id));
  };

  const applyLabels=async()=>{
    if(!selFeed)return;
    setLoadingPreview(true);setTab('preview');setPreviewError('');
    try{
      const r=await fetch(`${API}/feeds/${selFeed.id}/apply-labels`,{method:'POST',headers:authH(),body:'{}'});
      if(!r.ok) throw new Error(`HTTP ${r.status}`);
      const data=await r.json();
      setPreview(data.products||[]);
      if(!(data.products||[]).length) setPreviewError(t('Bu feed için ürün bulunamadı.'));
    }catch(e){
      setPreview([]);
      setPreviewError(t('Önizleme yüklenirken hata oluştu. Lütfen tekrar deneyin.'));
    }
    setLoadingPreview(false);
  };

  const loadSegProducts=async()=>{
    if(!selFeed)return;
    setLoadingSegProds(true);
    const r=await fetch(`${API}/feeds/${selFeed.id}/products?limit=100`,{headers:authH()});
    const data=await r.json();
    setSegProducts(data.products||[]);
    setLoadingSegProds(false);
  };

  const createSegment=async()=>{
    if(!selFeed||!newSeg.name)return;
    const r=await fetch(`${API}/feeds/${selFeed.id}/segments`,{method:'POST',headers:authH(),
      body:JSON.stringify({...newSeg,product_ids:Array.from(selProducts)})});
    if(r.ok){
      const updated=await fetch(`${API}/feeds/${selFeed.id}/segments`,{headers:authH()}).then(r=>r.json());
      setSegments(updated);setShowSegForm(false);setSelProducts(new Set());setSegProducts([]);
      setNewSeg({name:'',filter_type:'',filter_value:{}});
    }
  };

  const deleteSegment=async(id:number)=>{
    await fetch(`${API}/segments/${id}`,{method:'DELETE',headers:authH()});
    setSegments(prev=>prev.filter(s=>s.id!==id));
  };

  const selFilterType=FILTER_TYPES.find(f=>f.id===newRule.filter_type);

  return(
    <div style={{fontFamily:"Manrope, sans-serif",padding:'0 0 40px 0',minWidth:0}}>

      {/* Açıklama */}
      <div style={{marginBottom:20,marginTop:4}}>
        <p style={{fontSize:13,color:MT}}>{t("Custom label atayın, segment feed'ler oluşturun, Google & Meta reklamlarında hedefleme yapın.")}</p>
      </div>

      {/* Feed seçici */}
      <div style={{marginBottom:20,display:'flex',gap:8,flexWrap:'wrap' as const,alignItems:'center'}}>
        {feeds.map(f=>(
          <button key={f.id} onClick={()=>selectFeed(f)} style={{padding:'7px 15px',borderRadius:999,fontSize:12,fontWeight:700,cursor:'pointer',background:selFeed?.id===f.id?GOLD:SURFACE,color:selFeed?.id===f.id?T.accentInk:MT,border:`1px solid ${selFeed?.id===f.id?GOLD:BORDER}`}}>
            {f.name} {f.total_count?`(${f.total_count})`:''}
          </button>
        ))}
        <button onClick={()=>setShowAddFeed(v=>!v)} style={{padding:'7px 14px',borderRadius:999,fontSize:12,fontWeight:700,cursor:'pointer',background:showAddFeed?T.amberTint:SURFACE,color:showAddFeed?T.accentDeep:MT,border:`1px solid ${showAddFeed?alpha(T.accentDeep, 35):BORDER}`}}>
          {t('Feed Ekle')}
        </button>
        <button onClick={()=>setTopTab(prevTab=>prevTab==='settings'?'main':'settings')} style={{padding:'7px 14px',borderRadius:999,fontSize:12,fontWeight:700,cursor:'pointer',background:topTab==='settings'?T.amberTint:SURFACE,color:topTab==='settings'?T.accentDeep:MT,border:`1px solid ${topTab==='settings'?alpha(T.accentDeep, 35):BORDER}`}}>
          {t('Ayarlar')}
        </button>
      </div>

      {topTab==='settings' ? (
        <FeedRegistrySettings feedRegistry={feeds} clients={clients} onChange={()=>reloadFeeds(true)}/>
      ) : (<>

      {/* Feed ekleme formu */}
      {showAddFeed&&(
        <div style={{background:TILE,borderRadius:14,padding:16,border:`1px solid ${BORDER_MID}`,marginBottom:20}}>
          <div style={{fontSize:13,fontWeight:800,color:TX,marginBottom:12}}>{t('Yeni Feed Bağla')}</div>
          <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'1fr 1fr auto',gap:10,alignItems:'end'}}>
            <div>
              <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Feed Adı')}</div>
              <input value={newFeed.name} onChange={e=>setNewFeed(f=>({...f,name:e.target.value}))} placeholder={t('örn: Marka Google Feed')} style={inp}/>
            </div>
            <div>
              <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Feed Tipi')}</div>
              <select value={newFeed.feed_type} onChange={e=>setNewFeed(f=>({...f,feed_type:e.target.value}))} style={inp}>
                <option value="google">Google Shopping</option>
                <option value="meta">Meta Catalog</option>
              </select>
            </div>
            <div/>
          </div>
          <div style={{marginTop:10}}>
            <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>XML Feed URL</div>
            <input value={newFeed.src_url} onChange={e=>setNewFeed(f=>({...f,src_url:e.target.value}))} placeholder="https://example.com/feed.xml" style={inp}/>
          </div>
          {feedError&&<div style={{fontSize:11.5,color:RED,marginTop:8}}>{feedError}</div>}
          <div style={{display:'flex',gap:8,marginTop:12}}>
            <button onClick={addFeed} disabled={savingFeed} style={{flex:1,padding:'9px 16px',borderRadius:11,background:GOLD,border:'none',fontSize:13,fontWeight:700,cursor:'pointer',color:'#fff'}}>
              {savingFeed?t('Ekleniyor…'):t('Feed Bağla')}
            </button>
            <button onClick={()=>{setShowAddFeed(false);setFeedError('');}} style={{padding:'9px 16px',borderRadius:10,background:SURFACE,border:`1px solid ${T.borderMid}`,fontSize:12.5,fontWeight:700,cursor:'pointer',color:MT}}>{t('İptal')}</button>
          </div>
        </div>
      )}

      {!selFeed&&(
        <div style={{textAlign:'center' as const,padding:'60px 20px',color:DIM,border:`1px solid ${BORDER}`,borderRadius:16,background:SURFACE}}>
          <div style={{fontSize:14,fontWeight:700,color:TX,marginBottom:4}}>{t('Önce Feed Bağlayın')}</div>
          <div style={{fontSize:12.5}}>{t("Feed Wizard'dan bir feed bağlayın.")}</div>
        </div>
      )}

      {selFeed&&(
        <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'280px 1fr',gap:16,alignItems:'start'}}>

          {/* Sol: İstatistikler */}
          <div>
            <div style={{background:SURFACE,borderRadius:14,border:`1px solid ${BORDER}`,padding:'16px 18px',marginBottom:16}}>
              <div style={{fontSize:10.5,fontWeight:800,color:MT,textTransform:'uppercase' as const,letterSpacing:'.09em',marginBottom:14}}>{t('Feed İstatistikleri')}</div>
              {loadingStats&&<PoyaisSpinner size={26} pad={10}/>}
              {stats&&(<>
                <div style={{fontSize:24,fontWeight:800,color:TX,marginBottom:2,fontFamily:MONO}}>{stats.total.toLocaleString()}</div>
                <div style={{fontSize:11.5,color:MT,marginBottom:18}}>{t('toplam ürün')}</div>

                <div style={{fontSize:10,fontWeight:800,color:DIM,textTransform:'uppercase' as const,letterSpacing:'.09em',marginBottom:9}}>{t('Kategoriler')}</div>
                {Object.entries(stats.categories).slice(0,5).map(([k,v]:any)=>(
                  <StatBar key={k} label={k} value={v} max={Math.max(...Object.values(stats.categories) as number[])} color={GOLD}/>
                ))}

                <div style={{fontSize:10,fontWeight:800,color:DIM,textTransform:'uppercase' as const,letterSpacing:'.09em',marginBottom:9,marginTop:14}}>{t('Fiyat Dağılımı')}</div>
                {Object.entries(stats.price_ranges).map(([k,v]:any)=>(
                  <StatBar key={k} label={k+' TL'} value={v} max={Math.max(...Object.values(stats.price_ranges) as number[])} color={T.blueText}/>
                ))}

                <div style={{fontSize:10,fontWeight:800,color:DIM,textTransform:'uppercase' as const,letterSpacing:'.09em',marginBottom:9,marginTop:14}}>{t('İndirim Dağılımı')}</div>
                {Object.entries(stats.discounts).map(([k,v]:any)=>(
                  <StatBar key={k} label={k==='Indirimsiz'?t('İndirimsiz'):'%'+k} value={v} max={Math.max(...Object.values(stats.discounts) as number[])} color={GREEN}/>
                ))}
              </>)}
            </div>
          </div>

          {/* Sağ: Ana içerik */}
          <div>
            {/* Tab */}
            <div style={{display:'flex',gap:3,marginBottom:16,background:TRACK,borderRadius:10,padding:3,width:'fit-content',overflowX:'auto' as const}}>
              {[{k:'labels',l:'Custom Label'},  {k:'segments',l:'Segment Feed'},{k:'preview',l:t('Önizleme')}].map(tabDef=>(
                <button key={tabDef.k} onClick={()=>setTab(tabDef.k as any)} style={{padding:'7px 15px',borderRadius:8,fontSize:12,fontWeight:tab===tabDef.k?700:600,cursor:'pointer',background:tab===tabDef.k?SURFACE:'transparent',color:tab===tabDef.k?TX:MT,border:'none',boxShadow:tab===tabDef.k?'0 1px 2px rgba(20,22,43,.1)':'none'}}>
                  {tabDef.l}
                </button>
              ))}
            </div>

            {/* Custom Label tab */}
            {tab==='labels'&&(
              <div>
                <div style={{display:'flex',flexWrap:'wrap' as const,justifyContent:'space-between',alignItems:'center',gap:8,marginBottom:16}}>
                  <div>
                    <div style={{fontSize:13.5,fontWeight:800,color:TX}}>{t('Custom Label Kuralları')}</div>
                    <div style={{fontSize:11.5,color:MT,marginTop:3}}>{t('Koşullara göre ürünlere otomatik label ata.')}</div>
                  </div>
                  <div style={{display:'flex',gap:8}}>
                    <button onClick={applyLabels} style={{padding:'8px 15px',borderRadius:9,background:SURFACE,border:`1px solid ${T.borderMid}`,fontSize:12,fontWeight:700,cursor:'pointer',color:TX}}>
                      {t('Önizle')}
                    </button>
                    <button onClick={()=>setShowRuleForm(true)} style={{padding:'9px 16px',borderRadius:11,background:GOLD,border:'none',fontSize:13,fontWeight:700,cursor:'pointer',color:'#fff'}}>
                      {t('Kural Ekle')}
                    </button>
                  </div>
                </div>

                {/* Kural listesi */}
                {rules.length===0&&!showRuleForm&&(
                  <div style={{textAlign:'center' as const,padding:'40px 20px',background:TILE,border:`1px solid ${BORDER_MID}`,borderRadius:14,color:MT}}>
                    <div style={{fontSize:13,fontWeight:700,color:TX,marginBottom:4}}>{t('Henüz kural yok')}</div>
                    <div style={{fontSize:11.5}}>{t('Custom label kuralı ekleyerek ürünleri segmentlere ayırın.')}</div>
                  </div>
                )}

                <div style={{display:'flex',flexDirection:'column' as const,gap:9,marginBottom:16}}>
                  {rules.map(r=>{
                    const ft=FILTER_TYPES.find(f=>f.id===r.filter_type);
                    return(
                      <div key={r.id} style={{background:SURFACE,border:`1px solid ${BORDER}`,borderRadius:12,padding:'13px 15px',display:'flex',alignItems:'center',gap:12}}>
                        <div style={{width:8,height:8,borderRadius:4,background:GOLD,flexShrink:0}}/>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:3}}>
                            <span style={{fontSize:12.5,fontWeight:700,color:TX}}>{r.label_value}</span>
                            <span style={{fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:999,background:T.amberTint,color:T.accentDeep}}>{r.label_slot}</span>
                          </div>
                          <div style={{fontSize:11.5,color:MT}}>{ft?t(ft.label):r.filter_type} — {JSON.parse(r.filter_value||'{}').value||JSON.parse(r.filter_value||'{}').min||t('Tümü')}</div>
                        </div>
                        <div style={{fontSize:11,color:DIM,fontWeight:600}}>{t('Öncelik')}: {r.priority}</div>
                        <button onClick={()=>deleteRule(r.id)} style={{fontSize:11,color:RED,background:T.redTint,border:'none',borderRadius:8,padding:'4px 10px',cursor:'pointer',flexShrink:0,fontWeight:700}}>{t('Sil')}</button>
                      </div>
                    );
                  })}
                </div>

                {/* Yeni kural formu */}
                {showRuleForm&&(
                  <div style={{background:TILE,borderRadius:14,padding:16,border:`1px solid ${BORDER_MID}`}}>
                    <div style={{fontSize:13,fontWeight:800,color:TX,marginBottom:12}}>{t('Yeni Kural')}</div>
                    <div style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'1fr 1fr',gap:10,marginBottom:10}}>
                      <div>
                        <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Label Değeri')}</div>
                        <div style={{display:'flex',gap:5,flexWrap:'wrap' as const,marginBottom:7}}>
                          {LABEL_PRESETS.slice(0,7).map(p=>(
                            <button key={p} onClick={()=>setNewRule(r=>({...r,label_value:p}))} style={{fontSize:10,padding:'3px 9px',borderRadius:999,border:`1px solid ${newRule.label_value===p?GOLD:T.borderMid}`,background:newRule.label_value===p?T.amberTint:SURFACE,color:newRule.label_value===p?T.accentDeep:MT,cursor:'pointer',fontWeight:600}}>
                              {p}
                            </button>
                          ))}
                        </div>
                        <input value={newRule.label_value} onChange={e=>setNewRule(r=>({...r,label_value:e.target.value}))} placeholder={t('veya özel değer girin')} style={inp}/>
                      </div>
                      <div>
                        <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Label Slot')}</div>
                        <select value={newRule.label_slot} onChange={e=>setNewRule(r=>({...r,label_slot:e.target.value}))} style={inp}>
                          {LABEL_SLOTS.map(s=><option key={s} value={s}>{s}</option>)}
                        </select>
                      </div>
                    </div>
                    <div style={{marginBottom:10}}>
                      <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Filtre Koşulu')}</div>
                      <select value={newRule.filter_type} onChange={e=>setNewRule(r=>({...r,filter_type:e.target.value,filter_value:{}}))} style={inp}>
                        {FILTER_TYPES.map(f=><option key={f.id} value={f.id}>{t(f.label)}</option>)}
                      </select>
                    </div>
                    {selFilterType&&selFilterType.fields.length>0&&(
                      <div style={{display:'grid',gridTemplateColumns:`repeat(${selFilterType.fields.length},1fr)`,gap:8,marginBottom:10}}>
                        {selFilterType.fields.map(field=>(
                          <div key={field.k}>
                            <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t(field.l)}</div>
                            {field.type==='select'?(
                              <select value={newRule.filter_value[field.k]||''} onChange={e=>setNewRule(r=>({...r,filter_value:{...r.filter_value,[field.k]:e.target.value}}))} style={inp}>
                                {(field as any).options?.map((o:string)=><option key={o} value={o}>{o}</option>)}
                              </select>
                            ):(
                              <input type={field.type} value={newRule.filter_value[field.k]||''} onChange={e=>setNewRule(r=>({...r,filter_value:{...r.filter_value,[field.k]:e.target.value}}))} placeholder={t(field.l)} style={inp}/>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                    <div style={{display:'grid',gridTemplateColumns:'1fr auto',gap:8,marginBottom:10}}>
                      <div>
                        <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Kural Adı (opsiyonel)')}</div>
                        <input value={newRule.name} onChange={e=>setNewRule(r=>({...r,name:e.target.value}))} placeholder={t('Kural adı')} style={inp}/>
                      </div>
                      <div>
                        <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Öncelik')}</div>
                        <input type="number" value={newRule.priority} onChange={e=>setNewRule(r=>({...r,priority:Number(e.target.value)}))} style={{...inp,width:70}} min={0} max={100}/>
                      </div>
                    </div>
                    <div style={{display:'flex',gap:8}}>
                      <button onClick={addRule} style={{flex:1,padding:'9px 16px',borderRadius:11,background:GOLD,border:'none',fontSize:13,fontWeight:700,cursor:'pointer',color:'#fff'}}>{t('Kaydet')}</button>
                      <button onClick={()=>setShowRuleForm(false)} style={{padding:'9px 16px',borderRadius:10,background:SURFACE,border:`1px solid ${T.borderMid}`,fontSize:12.5,fontWeight:700,cursor:'pointer',color:MT}}>{t('İptal')}</button>
                    </div>
                  </div>
                )}

                {/* Açıklama */}
                <div style={{marginTop:16,padding:'13px 15px',background:T.blueTint,border:`1px solid ${alpha(T.blueText, 25)}`,borderRadius:12}}>
                  <div style={{fontSize:11.5,fontWeight:700,color:T.blueText,marginBottom:5}}>{t('Custom Label Nasıl Çalışır?')}</div>
                  <div style={{fontSize:11.5,color:MT,lineHeight:1.6}}>
                    {t('Google Ads ve Meta\'da custom_label_0-4 alanlarını kampanya hedefleme için kullanabilirsiniz. Örn: "İndirimli" label\'ı olan ürünlere farklı teklif stratejisi uygulayın.')}
                  </div>
                </div>
              </div>
            )}

            {/* Segment Feed tab */}
            {tab==='segments'&&(
              <div>
                <div style={{display:'flex',flexWrap:'wrap' as const,justifyContent:'space-between',alignItems:'center',gap:8,marginBottom:16}}>
                  <div>
                    <div style={{fontSize:13.5,fontWeight:800,color:TX}}>{t("Segment Feed'ler")}</div>
                    <div style={{fontSize:11.5,color:MT,marginTop:3}}>{t('Seçili ürünlerden yeni feed oluşturun.')}</div>
                  </div>
                  <button onClick={()=>{setShowSegForm(true);loadSegProducts();}} style={{padding:'9px 16px',borderRadius:11,background:GOLD,border:'none',fontSize:13,fontWeight:700,cursor:'pointer',color:'#fff'}}>
                    {t('Segment Oluştur')}
                  </button>
                </div>

                {/* Segment listesi */}
                {segments.length===0&&!showSegForm&&(
                  <div style={{textAlign:'center' as const,padding:'40px 20px',background:TILE,border:`1px solid ${BORDER_MID}`,borderRadius:14,color:MT}}>
                    <div style={{fontSize:13,fontWeight:700,color:TX,marginBottom:4}}>{t('Henüz segment yok')}</div>
                    <div style={{fontSize:11.5}}>{t("Belirli ürün gruplarından özel feed'ler oluşturun.")}</div>
                  </div>
                )}

                <div style={{display:'flex',flexDirection:'column' as const,gap:9,marginBottom:16}}>
                  {segments.map(s=>{
                    const ids=JSON.parse(s.product_ids||'[]');
                    const feedUrl=`/api/v1/dynamic-feed/segments/${s.id}/feed.xml`;
                    return(
                      <div key={s.id} style={{background:SURFACE,border:`1px solid ${BORDER}`,borderRadius:12,padding:'13px 15px'}}>
                        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:9,flexWrap:'wrap' as const,gap:8}}>
                          <div>
                            <div style={{fontSize:13,fontWeight:700,color:TX}}>{s.name}</div>
                            <div style={{fontSize:11.5,color:MT,marginTop:2}}>{ids.length} {t('ürün')}</div>
                          </div>
                          <div style={{display:'flex',gap:6,flexWrap:'wrap' as const}}>
                            <button onClick={()=>{navigator.clipboard.writeText(window.location.origin+feedUrl);}} style={{fontSize:11,padding:'5px 11px',borderRadius:8,border:`1px solid ${T.borderMid}`,background:SURFACE,cursor:'pointer',color:MT,fontWeight:700}}>
                              {t('URL Kopyala')}
                            </button>
                            <a href={feedUrl} target="_blank" rel="noreferrer" style={{fontSize:11,padding:'5px 11px',borderRadius:8,border:`1px solid ${GOLD}`,background:T.amberTint,color:T.accentDeep,fontWeight:700,textDecoration:'none'}}>
                              {t('XML Görüntüle')}
                            </a>
                            <button onClick={()=>setConnectGuide({seg:s,platform:'google'})} style={{fontSize:11,padding:'5px 11px',borderRadius:8,border:`1px solid ${alpha(T.blueText, 25)}`,background:T.blueTint,color:T.blueText,fontWeight:700,cursor:'pointer'}}>
                              {t("Google Ads'e Bağla")}
                            </button>
                            <button onClick={()=>setConnectGuide({seg:s,platform:'meta'})} style={{fontSize:11,padding:'5px 11px',borderRadius:8,border:`1px solid ${alpha(T.purpleText, 25)}`,background:T.purpleTint,color:T.purpleText,fontWeight:700,cursor:'pointer'}}>
                              {t("Meta Ads'e Bağla")}
                            </button>
                            <button onClick={()=>deleteSegment(s.id)} style={{fontSize:11,color:RED,background:T.redTint,border:'none',borderRadius:8,padding:'5px 10px',cursor:'pointer',fontWeight:700}}>{t('Sil')}</button>
                          </div>
                        </div>
                        <div style={{fontSize:11,color:MT,fontFamily:MONO,background:TRACK,padding:'5px 9px',borderRadius:6,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const}}>
                          {window.location.origin+feedUrl}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Yeni segment formu */}
                {showSegForm&&(
                  <div style={{background:TILE,borderRadius:14,padding:16,border:`1px solid ${BORDER_MID}`}}>
                    <div style={{fontSize:13,fontWeight:800,color:TX,marginBottom:12}}>{t('Yeni Segment')}</div>
                    <div style={{marginBottom:10}}>
                      <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:5}}>{t('Segment Adı')}</div>
                      <input value={newSeg.name} onChange={e=>setNewSeg(s=>({...s,name:e.target.value}))} placeholder={t('örn: Premium Ürünler')} style={inp}/>
                    </div>
                    <div style={{fontSize:11.5,fontWeight:700,color:TX,marginBottom:9}}>
                      {t('Ürün Seç')} ({selProducts.size} {t('seçili')})
                      <button onClick={()=>{if(selProducts.size===segProducts.length)setSelProducts(new Set());else setSelProducts(new Set(segProducts.map((p:any)=>p.id)));}} style={{marginLeft:8,fontSize:10.5,padding:'2px 9px',borderRadius:999,border:`1px solid ${T.borderMid}`,background:SURFACE,cursor:'pointer',color:MT,fontWeight:600}}>
                        {selProducts.size===segProducts.length?t('Tümünü Kaldır'):t('Tümünü Seç')}
                      </button>
                    </div>
                    {loadingSegProds&&<div style={{fontSize:12.5,color:MT}}>{t('Ürünler yükleniyor…')}</div>}
                    <div style={{maxHeight:240,overflowY:'auto' as const,marginBottom:12,border:`1px solid ${BORDER}`,borderRadius:12}}>
                      {segProducts.map((p:any)=>(
                        <div key={p.id} onClick={()=>setSelProducts(prev=>{const n=new Set(prev);n.has(p.id)?n.delete(p.id):n.add(p.id);return n;})}
                          style={{display:'flex',alignItems:'center',gap:10,padding:'9px 13px',borderBottom:`1px solid ${BORDER_MID}`,cursor:'pointer',background:selProducts.has(p.id)?T.amberTint:SURFACE}}>
                          <div style={{width:16,height:16,borderRadius:5,border:`1.8px solid ${selProducts.has(p.id)?GOLD:T.borderSoft}`,background:selProducts.has(p.id)?GOLD:'transparent',flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
                            {selProducts.has(p.id)&&<span style={{fontSize:9,color:T.accentInk,fontWeight:900}}>✓</span>}
                          </div>
                          {p.img&&<img src={p.img} alt="" style={{width:32,height:32,objectFit:'cover' as const,borderRadius:6,flexShrink:0}}/>}
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:11.5,fontWeight:600,color:TX,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const}}>{p.title}</div>
                            <div style={{fontSize:10.5,color:MT}}>{p.price} {p.discount_pct>0&&<span style={{color:GREEN}}>%{p.discount_pct} {t('indirim')}</span>}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{display:'flex',gap:8}}>
                      <button onClick={createSegment} disabled={!newSeg.name||selProducts.size===0} style={{flex:1,padding:'9px',borderRadius:10,background:newSeg.name&&selProducts.size>0?GOLD:T.borderSoft,border:'none',fontSize:12.5,fontWeight:800,cursor:'pointer',color:newSeg.name&&selProducts.size>0?T.accentInk:MT}}>
                        {t('Segment Oluştur')} ({selProducts.size} {t('ürün')})
                      </button>
                      <button onClick={()=>{setShowSegForm(false);setSelProducts(new Set());setSegProducts([]);}} style={{padding:'9px 16px',borderRadius:10,background:SURFACE,border:`1px solid ${T.borderMid}`,fontSize:12.5,fontWeight:700,cursor:'pointer',color:MT}}>{t('İptal')}</button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Önizleme tab */}
            {tab==='preview'&&(
              <div>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16,flexWrap:'wrap' as const,gap:8}}>
                  <div>
                    <div style={{fontSize:13.5,fontWeight:800,color:TX}}>{t('Label Önizleme')}</div>
                    <div style={{fontSize:11.5,color:MT,marginTop:3}}>{t("Kurallara göre atanan label'ları görün.")}</div>
                  </div>
                  <button onClick={applyLabels} style={{padding:'8px 15px',borderRadius:9,background:SURFACE,border:`1px solid ${T.borderMid}`,fontSize:12,fontWeight:700,cursor:'pointer',color:TX}}>
                    {t('Yenile')}
                  </button>
                </div>
                {loadingPreview&&<div style={{fontSize:13,color:MT,padding:20,textAlign:'center' as const}}>{t('Ürünlere kurallar uygulanıyor…')}</div>}
                {!loadingPreview&&previewError&&<div style={{fontSize:12.5,color:RED,background:T.redTint,border:`1px solid ${alpha(T.redText, 25)}`,borderRadius:10,padding:'10px 14px',marginBottom:12}}>{previewError}</div>}
                {preview.length>0&&(
                  <div style={{border:`1px solid ${BORDER}`,borderRadius:14,overflow:'hidden'}}>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 60px 60px 60px 60px 60px',gap:0,background:TRACK,padding:'9px 12px',fontSize:10.5,fontWeight:800,color:DIM}}>
                      <div>{t('Ürün')}</div>
                      <div>L0</div><div>L1</div><div>L2</div><div>L3</div><div>L4</div>
                    </div>
                    {preview.slice(0,30).map((p:any,i:number)=>(
                      <div key={p.id} style={{display:'grid',gridTemplateColumns:'1fr 60px 60px 60px 60px 60px',gap:0,padding:'9px 12px',borderTop:`1px solid ${BORDER_MID}`,background:i%2===0?SURFACE:TILE}}>
                        <div style={{fontSize:11.5,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const,color:TX}}>{p.title}</div>
                        {LABEL_SLOTS.map(slot=>(
                          <div key={slot} style={{fontSize:10,color:p._applied_labels?.[slot]?T.accentDeep:DIM,fontWeight:p._applied_labels?.[slot]?700:400,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const}}>
                            {p._applied_labels?.[slot]||p[slot]||'—'}
                          </div>
                        ))}
                      </div>
                    ))}
                    {preview.length>30&&<div style={{padding:'9px 12px',fontSize:11.5,color:MT,textAlign:'center' as const}}>{lang==='en'?`+${preview.length-30} more products`:`+${preview.length-30} ürün daha`}</div>}
                  </div>
                )}
                {!loadingPreview&&preview.length===0&&(
                  <div style={{textAlign:'center' as const,padding:'40px 20px',background:TILE,border:`1px solid ${BORDER_MID}`,borderRadius:14,color:MT}}>
                    <div style={{fontSize:13}}>{t('Kural ekleyip "Önizle" butonuna tıklayın.')}</div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Platform bağlama rehberi */}
      {connectGuide&&(()=>{
        const feedUrl=window.location.origin+`/api/v1/dynamic-feed/segments/${connectGuide.seg.id}/feed.xml`;
        const isGoogle=connectGuide.platform==='google';
        const steps=isGoogle?[
          'merchantcenter.google.com adresine gidip ilgili hesabı seçin.',
          'Sol menüden Ürünler > Feedler\'e girin.',
          '"+" ile yeni feed ekleyin, ülke ve dili seçin.',
          'Giriş yöntemi olarak "Zamanlanmış getirme" (Scheduled fetch) seçeneğini işaretleyin.',
          'Aşağıdaki feed URL\'sini yapıştırın ve günlük getirme saatini ayarlayın.',
          'Merchant Center hesabı Google Ads\'e bağlıysa ürünler otomatik olarak Shopping / Performance Max kampanyalarında kullanılabilir hale gelir.',
        ]:[
          'business.facebook.com/commerce_manager adresine gidip ilgili kataloğu seçin (yoksa yeni katalog oluşturun).',
          'Veri Kaynakları > Yeni Veri Kaynağı Ekle\'ye girin.',
          'Giriş yöntemi olarak "Zamanlanmış Feed" seçeneğini işaretleyin.',
          'Aşağıdaki feed URL\'sini yapıştırın ve günlük getirme saatini ayarlayın.',
          'Katalog onaylandıktan sonra Meta Ads Yöneticisi\'nde dinamik ürün reklamları (DPA) oluşturabilirsiniz.',
        ];
        return(
          <div onClick={()=>setConnectGuide(null)} style={{position:'fixed',inset:0,background:'rgba(20,22,43,0.45)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
            <div onClick={e=>e.stopPropagation()} style={{background:T.surface,borderRadius:16,padding:'26px 28px',maxWidth:480,width:'100%',boxShadow:'0 20px 60px rgba(20,22,43,.25)'}}>
              <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:6}}>
                <img src={isGoogle?'/google-ads-icon.png':'/meta-icon.png'} alt="" style={{width:26,height:26,objectFit:'contain' as const}}/>
                <div style={{fontSize:15,fontWeight:800,color:TX}}>{isGoogle?t('Google Merchant Center\'a Bağlama'):t('Meta Commerce Manager\'a Bağlama')}</div>
              </div>
              <div style={{fontSize:12,color:MT,marginBottom:16}}>
                {lang==='en'
                  ? `To use the "${connectGuide.seg.name}" segment in ${isGoogle?'Google Shopping':'Meta Catalog'} ads:`
                  : `"${connectGuide.seg.name}" segmentini ${isGoogle?'Google Shopping':'Meta Katalog'} reklamlarında kullanmak için:`}
              </div>

              <div style={{display:'flex',flexDirection:'column' as const,gap:10,marginBottom:16}}>
                {steps.map((s,i)=>(
                  <div key={i} style={{display:'flex',gap:10,alignItems:'flex-start'}}>
                    <span style={{width:20,height:20,borderRadius:'50%',background:isGoogle?T.blueTint:T.purpleTint,color:isGoogle?T.blueText:T.purpleText,fontSize:11,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:1}}>{i+1}</span>
                    <div style={{fontSize:12.5,color:TX,lineHeight:1.5}}>{t(s)}</div>
                  </div>
                ))}
              </div>

              <div style={{fontSize:10.5,fontWeight:700,color:MT,marginBottom:6,textTransform:'uppercase' as const,letterSpacing:'.06em'}}>{t('Feed URL')}</div>
              <div style={{display:'flex',gap:8,marginBottom:16}}>
                <div style={{flex:1,fontSize:11,color:TX,fontFamily:MONO,background:TRACK,padding:'9px 11px',borderRadius:9,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' as const}}>
                  {feedUrl}
                </div>
                <button onClick={()=>navigator.clipboard.writeText(feedUrl)} style={{padding:'9px 14px',borderRadius:9,border:`1px solid ${T.borderMid}`,background:SURFACE,color:TX,fontSize:12,fontWeight:700,cursor:'pointer',flexShrink:0}}>
                  {t('Kopyala')}
                </button>
              </div>

              <div style={{background:T.amberTintAlt,border:`1px solid ${alpha(T.amberDeepText, 30)}`,borderRadius:9,padding:'10px 12px',marginBottom:16}}>
                <div style={{fontSize:11.5,color:T.amberDeepText}}>
                  {t('Getirme sıklığını platform üzerinden ayarlarsınız, Poyais One tarafında ek bir işlem gerekmez. Segmentteki ürünleri güncellediğinizde bu URL\'deki içerik de otomatik güncellenir.')}
                </div>
              </div>

              <button onClick={()=>setConnectGuide(null)} style={{width:'100%',padding:'9px 16px',background:GOLD,color:'#fff',border:'none',borderRadius:11,fontSize:13,fontWeight:700,cursor:'pointer'}}>
                {t('Anladım')}
              </button>
            </div>
          </div>
        );
      })()}
      </>)}
    </div>
  );
}
